import React, { useState } from 'react';
import Layout from './Layout';
import { defaultAxiosInstance } from '../api/defaultInstance';
import { useNavigate } from 'react-router-dom';
import '../css/AdProductWrite.css';

function NewsReleaseCategoryWrite() {
    const navigate = useNavigate();
    const [formData, setFormData] = useState({
        name: '',
        description: '',
        labels: '',
        startPrice: ''
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        // 라벨 문자열을 JSON 배열로 변환
        const labelsArray = formData.labels
            .split(',')
            .map(label => label.trim())
            .filter(label => label !== '');

        const payload = {
            ...formData,
            labels: labelsArray,
            startPrice: Number(formData.startPrice)
        };

        try {
            const response = await defaultAxiosInstance.post('/advertisement/admin/newsRelease/category', payload);
            if (response.data.status === 200) {
                alert('카테고리가 성공적으로 등록되었습니다.');
                navigate('/ads/newsRelease/categories');
            } else {
                alert('카테고리 등록에 실패했습니다.');
            }
        } catch (error) {
            console.error('카테고리 등록 오류:', error);
            alert('카테고리 등록 중 오류가 발생했습니다.');
        }
    };

    return (
        <Layout>
            <div className="ad-product-write-container">
                <h2>언론배포 카테고리 등록</h2>
                <form className="ad-product-write-form" onSubmit={handleSubmit}>
                    <div className="form-group">
                        <label>카테고리명</label>
                        <input
                            type="text"
                            name="name"
                            value={formData.name}
                            onChange={handleChange}
                            required
                        />
                    </div>
                    <div className="form-group full-width">
                        <label>카테고리 설명</label>
                        <textarea
                            name="description"
                            value={formData.description}
                            onChange={handleChange}
                            required
                        />
                    </div>
                    <div className="form-group">
                        <label>라벨 (쉼표로 구분)</label>
                        <input
                            type="text"
                            name="labels"
                            value={formData.labels}
                            onChange={handleChange}
                            placeholder="예: 뉴스,보도자료,언론"
                        />
                    </div>
                    <div className="form-group">
                        <label>시작 금액</label>
                        <input
                            type="number"
                            name="startPrice"
                            value={formData.startPrice}
                            onChange={handleChange}
                            required
                        />
                    </div>
                    <div className="form-group submit-group">
                        <button type="submit">저장하기</button>
                    </div>
                </form>
            </div>
        </Layout>
    );
}

export default NewsReleaseCategoryWrite; 